module.exports = __webpack_public_path__ + "static/media/COL.e31ffbe8.png";